import { useQuery } from "@tanstack/react-query";
import { getPublicAnsweringSubjects } from "@/lib/api/public-flow/answering-subjects";
import { useSessionToken } from "@/lib/context/public-session-context";

export const publicAnsweringSubjectsKeys = {
  value: ["publicFlow", "answering-subjects"] as const,
};

/**
 * QL-505 — client-session mirror of `useAnsweringSubjects`. `sessionSubjectId`
 * is set only on a member-scoped session (a member link): the one member line
 * that session may act on, and the signal the member-session flow view uses
 * to strip the flow down to just the PA/quiz components.
 */
export function usePublicAnsweringSubjects() {
  const token = useSessionToken();
  const { data, error, isLoading } = useQuery({
    queryKey: publicAnsweringSubjectsKeys.value,
    queryFn: () => getPublicAnsweringSubjects(token),
    enabled: !!token,
  });
  return {
    attribution: data?.attribution ?? null,
    sessionSubjectId: data?.sessionSubjectId ?? null,
    error,
    isLoading,
  };
}
